import { relations } from 'drizzle-orm'
import { pgTable } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { Contracts } from './contracts'
import { Organizations } from './organizations'
import { timestamps } from './shared'
import { Users } from './users'
import { Vendors } from './vendors'

export const SubscriptionHistory = pgTable('subscription_history', (t) => ({
  contractId: t
    .text('contract_id')
    .notNull()
    .references(() => Contracts.id, { onDelete: 'cascade' }),
  parentContractId: t
    .text('parent_contract_id')
    .references(() => Contracts.id, { onDelete: 'set null' }),
  vendorId: t
    .text('vendor_id')
    .notNull()
    .references(() => Vendors.id, { onDelete: 'cascade' }),
  uniqueTransactionId: t.text('unique_transaction_id').notNull(),
  orgId: t
    .text('org_id')
    .notNull()
    .references(() => Organizations.id, { onDelete: 'cascade' }),
  transactionDate: t.text('transaction_date'),
  createdBy: t
    .text('created_by')
    .notNull()
    .references(() => Users.id, { onDelete: 'restrict' }),
  ...timestamps
}))

export type SubscriptionHistoryRecord = typeof SubscriptionHistory.$inferSelect
export type SubscriptionHistoryInsert = typeof SubscriptionHistory.$inferInsert

export const insertSubscriptionHistorySchema =
  createInsertSchema(SubscriptionHistory)
export const selectSubscriptionHistorySchema =
  createSelectSchema(SubscriptionHistory)

export const subscriptionHistoryRelations = relations(
  SubscriptionHistory,
  ({ one }) => ({
    contract: one(Contracts, {
      fields: [SubscriptionHistory.contractId],
      references: [Contracts.id]
    }),
    parentContract: one(Contracts, {
      fields: [SubscriptionHistory.parentContractId],
      references: [Contracts.id]
    }),
    vendor: one(Vendors, {
      fields: [SubscriptionHistory.vendorId],
      references: [Vendors.id]
    }),
    organization: one(Organizations, {
      fields: [SubscriptionHistory.orgId],
      references: [Organizations.id]
    }),
    createdBy: one(Users, {
      fields: [SubscriptionHistory.createdBy],
      references: [Users.id]
    })
  })
)
